"use client"
import React from 'react'
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { useTheme } from '@/app/theme-provider';

const Righttoservice = () => {
    const{language}=useTheme()

    //  const [page, setPage] = useState(1);
    const { data: list, loading, error } = useFetch(
        "/website/general-information-rts",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    //  const [page, setPage] = useState(1);
    const { data: listdatadynamic, } = useFetch(
        "/website/general-information-rts-dynamic-content",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    return (
        <>
            <section className='mt-4'>
                <h4 className='center'>{language=="en"?"SERVICES GIVEN BY VIGILANCE AND ANTI-CORRUPTION BUREAU":"വിജിലൻസ് ആൻഡ് ആന്റി-കൊറപ്ഷൻ ബ്യൂറോ നൽകുന്ന സേവനങ്ങൾ"}</h4>
                <div className="table-responsive tenders-table">
                    
                    <table className="table  table-bordered text-center align-middle ">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">{language=="en"?"Sl No.":"ക്രമം നമ്പർ"}</th>
                                <th scope="col">{language=="en"?"Service":"സേവനം"}</th>
                                <th scope="col">{language=="en"?"Time Limit":"സമയ പരിധി"}</th>
                                <th scope="col">{language=="en"?"Responsible Officer":"ഉത്തരവാദപ്പെട്ട ഉദ്യോഗസ്ഥൻ"}</th>
                                <th scope="col">{language=="en"?"First Appellate Authority":"ഒന്നാം അപ്പീൽ അതോറിറ്റി"}</th>
                                <th scope="col">{language=="en"?"Second Appellate Authority":"രണ്ടാം അപ്പലേറ്റ് അതോറിറ്റി"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list?.length > 0 ? (
                                <>
                                    {list?.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td className='algndata'>{item.name}</td>
                                                <td>
                                                    {item.timelimit}
                                                </td>
                                                <td>
                                                    {item.responsible_officer}
                                                </td>
                                                <td>
                                                    {item.first_appellate_authority}
                                                </td>
                                                <td>
                                                    {item.second_appellate_authority}
                                                </td>
                                            </tr>

                                        </>
                                    ))}


                                </>
                            ) : <>
                                <tr>
                                    <td colSpan={6}>
                                        No data found
                                    </td>
                                </tr>
                            </>}


                        </tbody>
                    </table>
                </div>
            </section>
            {listdatadynamic?.length > 0 && (
                <section className="mt-4">
                    <div className="table-responsive tenders-table">
                        {/* <h4 className="center">Additional Information</h4> */}
                        {listdatadynamic.map((item, index) => (
                            <div
                                key={item.id || index}
                                className="dynamic-table-content mt-3"
                                dangerouslySetInnerHTML={{
                                    __html: item.details.replace(
                                        /<table/g,
                                        '<table class="table table-bordered text-center align-middle"'
                                    ),
                                }}
                            />
                        ))}
                    </div>
                </section>
            )}

        </>
    )
}

export default Righttoservice
